// styles
import { GirdedInfoIcon } from 'refactored/ui/icons';
import styled from 'styled-components';
import LiteralCurrency from 'components/LiteralCurrency';
import LoadSpinner from 'components/LoadSpinner';
import { useTranslation } from 'react-i18next';

const SoFormCandidateBlockPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 16px;
  margin-left: auto;
  border-radius: 0px 4px 4px 0px;
  /* border: 1px solid blue; */
  width: 150px;
`;

const SoFormCandidateBlockFromText = styled.div`
  height: 16px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: var(--grey500);
`;

const SoFormCandidateBlockAmountText = styled.div`
  height: 32px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: var(--grey800);
  flex: none;
  order: 1;
  flex-grow: 0;
`;

const AccentText = styled.div`
  /* 14px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* accent / 700 */

  color: var(--accent700);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 4px;

  width: 90px;
  height: 24px;

  border-radius: 4px;
  text-align: right;
  justify-content: end;
  svg {
    path {
      fill: var(--accent700);
    }
  }
`;

const SoFormCandidateBlockFromTextContent = ({ candidate }) => {
  const { t } = useTranslation('Catalog');
  const pricingStrategy = candidate.pricing_strategy;

  if (pricingStrategy === 'INSTANT') return <>{t('price.from')}</>;
  else if (pricingStrategy === 'RFQ')
    return (
      <AccentText>
        <GirdedInfoIcon />
      </AccentText>
    );
  else if (pricingStrategy === 'RFQ_RANGE')
    return (
      <AccentText>
        {t('price.estimate')} <GirdedInfoIcon />
      </AccentText>
    );
};

const RangeText = styled.div`
  width: 105px;
  height: 16px;

  /* 14px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  /* grey / 800 */

  color: #3b4f63;

  margin-top: 8px;
`;

const RFQInfoTextContainer = styled.div`
  margin-top: 12px;
`;

const SoFormCandidateBlockAmountTextContent = ({ candidate }) => {
  const { t } = useTranslation('Catalog');

  const isUpdating = candidate.formData.isUpdating;

  const pricingStrategy = candidate.pricing_strategy;
  const total = parseFloat(candidate.formData.quote.net_full_price);

  const ESTIMATION_PRICE_PERCENTAGE = 50;
  const rangeFrom = parseFloat(total);
  const rangeTo =
    parseFloat(total) + (ESTIMATION_PRICE_PERCENTAGE * parseFloat(total)) / 100;

  if (pricingStrategy === 'INSTANT')
    return (
      <>{isUpdating ? <LoadSpinner /> : <LiteralCurrency value={total} />}</>
    );
  else if (pricingStrategy === 'RFQ')
    return (
      <RFQInfoTextContainer>
        <AccentText>{t('price.rfq_price_subject_to_review')}</AccentText>
      </RFQInfoTextContainer>
    );
  else if (pricingStrategy === 'RFQ_RANGE')
    return (
      <RangeText>
        <LiteralCurrency value={rangeFrom} />
        <span> - </span>
        <LiteralCurrency value={rangeTo} />
      </RangeText>
    );
};

const SoFormCandidateBlockSummaryPrice = ({ candidate }) => {
  return (
    <SoFormCandidateBlockPriceContainer>
      <SoFormCandidateBlockFromText>
        <SoFormCandidateBlockFromTextContent candidate={candidate} />
      </SoFormCandidateBlockFromText>
      <SoFormCandidateBlockAmountText>
        <SoFormCandidateBlockAmountTextContent candidate={candidate} />
      </SoFormCandidateBlockAmountText>
    </SoFormCandidateBlockPriceContainer>
  );
};

export default styled(SoFormCandidateBlockSummaryPrice)``;
